module.exports = require("./lib/_stream_writable.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/writable.js
// module id = 102
// module chunks = 2